import DomElementsBase from "@grindex-common/abstracts/DomElementsBase.class";
import { debounce } from "@grindex-common/helpers/debounce";
import { width, outerHeight, hideElement } from "@grindex-common/helpers/domManipulation";

const CLASS_CURRENT_IMAGE = "current-image";
const CLASS_FADE_IN = "fadeIn";

const SELECTOR_ARROWS = ".arrow";
const SELECTOR_CURRENT_IMAGE = ".current-image";
const SELECTOR_LOADER_PERCENTAGE = ".percentage-loader";
const SELECTOR_SLIDER = "#threesixty_slider";
const SELECTOR_SLIDER_IMAGE_CONTAINER = "#threesixty_images";
const SELECTOR_SLIDER_WRAPPER = ".slider-wrapper";

export class ImageRotateSliderDom extends DomElementsBase {
	constructor($module) {
		const selectors = [
			SELECTOR_ARROWS,
			SELECTOR_CURRENT_IMAGE,
			SELECTOR_LOADER_PERCENTAGE,
			SELECTOR_SLIDER,
			SELECTOR_SLIDER_IMAGE_CONTAINER,
			SELECTOR_SLIDER_WRAPPER,
		];

		super($module, selectors);
	}

	getWrapperElement() {
		return this.getElement(SELECTOR_SLIDER_WRAPPER);
	}

	getArrowElements() {
		return this.getElements(SELECTOR_ARROWS);
	}

	getImageContainerElement() {
		return this.getElement(SELECTOR_SLIDER_IMAGE_CONTAINER);
	}

	getSliderElement() {
		return this.getElement(SELECTOR_SLIDER);
	}

	getSliderWidth() {
		return width(this.getSliderElement());
	}

	getModuleWidth() {
		return width(this.$module);
	}

	getCurrentImage() {
		return this.getElement(SELECTOR_CURRENT_IMAGE, true);
	}

	getImages() {
		return this.getChildrenByTag(SELECTOR_SLIDER_IMAGE_CONTAINER, "img");
	}

	getLoaderPercentage() {
		return this.getElement(SELECTOR_LOADER_PERCENTAGE);
	}

	getCurrentImageHeight() {
		return outerHeight(this.getElement(SELECTOR_CURRENT_IMAGE, true));
	}

	setSliderWidth(sliderWidth) {
		this.getSliderElement().style.width = `${sliderWidth}px`;
	}

	setWrapperWidth(containerWidth) {
		this.getWrapperElement().style.width = `${containerWidth}px`;
	}

	setModuleHeight(height) {
		this.$module.style.height = `${height}px`;
	}

	hideArrows() {
		this.getArrowElements().forEach(($arrow) => {
			$arrow.classList.remove(CLASS_FADE_IN);
		});
	}

	hideLoaderPercentage() {
		hideElement(this.getLoaderPercentage());
	}

	hideContainer() {
		hideElement(this.$module);
	}

	hideImage(index) {
		this.getImages()[index].classList.remove(CLASS_CURRENT_IMAGE);
	}

	fadeInFirstImage() {
		const $firstImage = this.getImages()[0];
		$firstImage.classList.add(CLASS_FADE_IN);
		this.showImage(0);
		debounce(() => {
			$firstImage.classList.remove(CLASS_FADE_IN);
		}, 200);
	}

	fadeInArrows() {
		[...this.getArrowElements()].forEach(($arrow) => {
			$arrow.classList.add(CLASS_FADE_IN);
		});
	}

	showImage(index) {
		const $image = this.getImages()[index];
		$image.classList.add(CLASS_CURRENT_IMAGE);
	}
}
